import {SET_LOADING_GET_ISSUES, GET_ISSUES, GET_ISSUES_SUCCESS, GET_ISSUES_ERROR, 
    SET_LOADING_DELETE_ISSUE, DELETE_ISSUE, DELETE_ISSUE_SUCCESS, DELETE_ISSUE_ERROR, 
    TOGGLE_EDIT_ISSUE_MODAL} from '../actions/IssueActions';

const INITIAL_STATE = {
    loadingGetIssues: false, 
    loadingDeleteIssue: false,
    editIssueModalOpened: false
};

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case SET_LOADING_GET_ISSUES:
            return {...state, loadingGetIssues: true};
        case GET_ISSUES:
            return {...state}
        case GET_ISSUES_SUCCESS:
            return {...state, loadingGetIssues: false};
        case GET_ISSUES_ERROR:
            return {...state, loadingGetIssues: false};

        case SET_LOADING_DELETE_ISSUE:
            return {...state, loadingDeleteIssue: true};
        case DELETE_ISSUE:
            return {...state}
        case DELETE_ISSUE_SUCCESS:
            return {...state, loadingDeleteIssue: false};
        case DELETE_ISSUE_ERROR:
            return {...state, loadingDeleteIssue: false};
        
        case TOGGLE_EDIT_ISSUE_MODAL:
            return {...state, editIssueModalOpened: action.payload.force ? action.payload.open : !state.editIssueModalOpened};

        default:
            return state;
    }
}
